export const data = {
    serverName: 'Da Frens',
    logoPath: '/icon - square - rounded.webp',
    communityTagline: "A community for gamers, banter, and Frens - where sarcasm meets a surprising amount of heart! (21+ only, participation required)",
    featuresLinkText: 'Features',
    appealLinkText: 'Appeal Ban',
    joinLinkText: 'Join',
    gifShowcaseData: {
        gifPath: '/banner.mp4',
        gifShowcaseTitle: "Congrats! You've found Da Frens!",
        gifShowcaseDescription: `We keep it real and just the right amount of weird - with the occasional overshare. Expect hot banter, sweaty games, and zero trainwrecks! Join us and discover that maybe you aren't so strange after all - just an adult pretending to have it together like the rest of us. Fair warning: if you don't participate, don't fit the vibe, or are under 21, you'll get the boot.`,
        joinCommunityButtonText: 'Join Our Community',
    },
    vibeRulesData: {
        vibeRulesTitle: "What to Expect",
        rules: [
            {
                header: "We Banter",
                description: "Expect playful roasting and memes, not actual toxicity. We dish out sarcasm, but there's a dash of love behind it. If you can't handle the heat or never contribute to conversations, you won't last long."
            },
            {
                header: "21+ Only",
                description: "No exceptions - you're basically signing up for a bunch of pretend - grownups anyway. We will verify your age, and if you're under 21, you're getting kicked immediately."
            },
            {
                header: "Stay Active",
                description: "We enjoy your presence - ghost us, and you might get booted. Don't say we didn't warn you. If you join and never say anything, you're not a good fit and will be removed."
            },
            {
                header: "Keep the Vibes",
                description: "We're all for letting your freak flag fly, just don't ruin the party. Repeat vibe - killers get the axe. If you don't mesh with our energy or constantly bring down the mood, you won't last here."
            }
        ],
        vibeRulesNote: "For the full rundown on how we keep it (mostly) chill, check out our rules once you're in!",
    },
    featuresData: {
        featuresTitle: "Why Join Us?",
        featuresDescription: "Discover what makes our community special and why you should join us today! (Fair warning: we're selective about who stays)",
        features: [
            {
                icon: '💬',
                title: 'Chat & Get Roasted',
                description: `We hang out daily - sharing memes, TV recommendations, and random 3 AM thoughts. Don't sweat being quiet, but if you never speak up, expect some friendly roasting. It's all part of the good times! Warning: if you're a lurker who never contributes, you'll get the boot.`,
            },
            {
                icon: '🎮',
                title: 'Degen Gamers Unite',
                description: `From sweaty ranked matches to cozy co - op nights, we're always up for a game. And yeah, we might roast your K/D ratio if it tanks - but hey, it's our version of cheerleading.`,
            },
            {
                icon: '🤝',
                title: 'Active Mods, Minimal Rules',
                description: `We keep things laid - back but won't stand for anyone killing the mood. Bring your sarcastic best, stay involved, and you'll fit right in - just don't make us break out the banhammer. If you're not a good cultural fit, you won't last long here.`,
            },
        ],
    },
    embedData: {
        embedTitle: 'Da Frens',
        embedDescription: `Preview our server and see what's happening right now!`,
    },
    joinData: {
        joinTitle: 'Ready for Some Chaos?',
        joinDescription: `Step into our corner of the internet, where banter is currency and memes flow like fine wine. We're rowdy, but it's all in good fun - just watch your back if you can't handle a friendly roast or two (it's how we show love!). Fair warning: we're picky about who stays, so bring your A-game or expect to get the boot.`,
        joinButtonText: 'Join Discord',
    },
    appealData: {
        appealTitle: 'Managed to get hit with a ban?',
        appealDescription: `It takes a lot to be banned from Da Frens, but if you've managed to do it (congrats?), you can appeal your ban here. Just remember, we might not take you back if you were a real vibe - killer!`,
        appealButtonText: "Appeal Ban",
        appealButtonLink: "https://appeal.gg/dafrens",
    },
    footerData: {
        footerText: "Da Frens.",
        disboardText: "Disboard",
        disboardURL: "https://disboard.org/server/691991366615564388"
    }
};
